

<div class="paragraph">
  @if (title != null && title.length > 0) {
    <div class="paragraph-title">{{title}}</div>
  }
  <div class="paragraph-content" [innerHTML]="content"></div>
</div>